import React from 'react';
import { motion } from 'framer-motion';
export function Methodology() {
  const dimensions = [{
    num: '01',
    name: 'Credibilidad',
    question: '¿Tu sitio web transmite confianza desde el primer segundo?'
  }, {
    num: '02',
    name: 'Claridad',
    question: '¿Tu sitio web comunica inmediatamente qué hace tu empresa y a quién sirve?'
  }, {
    num: '03',
    name: 'Conversión',
    question: '¿Facilita que el visitante tome acción de forma natural?'
  }, {
    num: '04',
    name: 'Autoridad',
    question: '¿Demuestra la experiencia y trayectoria que tu empresa tiene?'
  }, {
    num: '05',
    name: 'Rendimiento',
    question: '¿Carga rápido y funciona correctamente en todos los dispositivos?'
  }];
  const renderCard = (dim: (typeof dimensions)[number], idx: number) => <motion.div key={idx} className="bg-arena-dark border border-salvia/25 rounded-[12px] p-8 hover:-translate-y-[2px] hover:shadow-card hover:border-verde/50 transition-all duration-200" initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.4,
    ease: 'easeOut',
    delay: idx * 0.08
  }} data-id="element-240">
      <span className="block font-body text-[11px] uppercase font-semibold text-azul tracking-widest mb-3" data-id="element-241">
        {dim.num}
      </span>
      <h3 className="font-display text-[22px] font-bold text-carbon mb-3" data-id="element-242">
        {dim.name}
      </h3>
      <p className="font-body text-[15px] font-medium text-carbon italic" data-id="element-243">
        {dim.question}
      </p>
    </motion.div>;
  return <section id="metodologia" className="bg-arena py-[72px] md:py-[120px]" data-id="element-244">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-245">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-12 md:mb-16" data-id="element-246">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-4" data-id="element-247">
            CÓMO EVALUAMOS TU SITIO WEB
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1] max-w-[520px] mb-6" data-id="element-248">
            Cinco dimensiones.
            <br data-id="element-249" />
            Un diagnóstico preciso de tu sitio web.
          </h2>
          <p className="font-body text-[18px] text-carbon/65 leading-[1.65] max-w-[560px] mb-[48px]" data-id="element-250">
            Desarrollamos el ICD™ para evaluar con criterios objetivos si un
            sitio web está a la altura del negocio que representa. Cinco
            dimensiones medibles. Un índice de 0 a 100. Sin opiniones de diseño.
          </p>
        </motion.div>

        {/* Row 1: 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-251">
          {dimensions.slice(0, 3).map((dim, idx) => renderCard(dim, idx))}
        </div>

        {/* Row 2: 2 columns centered */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-252">
          <div className="hidden md:block" data-id="element-253" />
          {dimensions.slice(3, 5).map((dim, idx) => <div key={idx + 3} className="md:col-span-1" data-id="element-254">
              {renderCard(dim, idx + 3)}
            </div>)}
        </div>

        {/* ICD Card */}
        <motion.div className="bg-verde rounded-[12px] p-[48px]" initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} data-id="element-255">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-[48px] items-center" data-id="element-256">
            <div data-id="element-257">
              <span className="block font-body text-[11px] uppercase font-medium text-arena/50 tracking-widest mb-4" data-id="element-258">
                RESULTADO DE LAS 5 DIMENSIONES
              </span>
              <h3 className="font-display text-[28px] md:text-[36px] font-bold text-arena mb-4" data-id="element-259">
                Índice de Confianza Digital™
              </h3>
              <p className="font-body text-[16px] text-arena/70 leading-relaxed mb-8" data-id="element-260">
                La evaluación de las cinco dimensiones genera un índice de 0 a
                100 que mide si tu sitio web está generando las oportunidades
                comerciales que debería. Es la base de cada decisión que tomamos
                al construirlo o rediseñarlo.
              </p>

              <div className="space-y-2 mb-4" data-id="element-261">
                {['Credibilidad', 'Claridad', 'Conversión', 'Autoridad', 'Rendimiento'].map(name => <div key={name} className="flex justify-between font-body text-[14px] text-arena/60" data-id="element-262">
                    <span data-id="element-263">{name}:</span>
                    <span data-id="element-264">20 puntos máximo</span>
                  </div>)}
              </div>
              <div className="border-t border-arena/20 pt-2 flex justify-between font-body text-[14px] font-semibold text-arena/80" data-id="element-265">
                <span data-id="element-266">TOTAL:</span>
                <span data-id="element-267">100 puntos</span>
              </div>
            </div>

            <div className="flex flex-col items-center md:items-end justify-center md:pl-6" data-id="element-268">
              <div className="relative w-48 h-48 flex items-center justify-center mb-8" data-id="element-269">
                <svg className="absolute inset-0 w-full h-full transform -rotate-90" data-id="element-270">
                  <circle cx="96" cy="96" r="88" stroke="rgba(247,244,237,0.1)" strokeWidth="8" fill="none" data-id="element-271" />
                  <circle cx="96" cy="96" r="88" stroke="#4F7CFF" strokeWidth="8" fill="none" strokeDasharray="552.9" strokeDashoffset="326.2" className="transition-all duration-1000" data-id="element-272" />
                </svg>
                <div className="text-center" data-id="element-273">
                  <span className="font-display text-[56px] font-bold text-azul leading-none" data-id="element-274">
                    41
                  </span>
                  <span className="font-display text-[24px] font-bold text-azul/50" data-id="element-275">
                    /100
                  </span>
                </div>
              </div>

              <div className="w-full max-w-[280px] space-y-2 mb-6" data-id="element-276">
                <div className="flex justify-between font-body text-[13px]" data-id="element-277">
                  <span className="text-[#E85555]" data-id="element-278">0-30:</span>
                  <span className="text-[#E85555]" data-id="element-279">Brecha crítica</span>
                </div>
                <div className="flex justify-between font-body text-[13px]" data-id="element-280">
                  <span className="text-[#E8A855]" data-id="element-281">31-50:</span>
                  <span className="text-[#E8A855]" data-id="element-282">Brecha significativa</span>
                </div>
                <div className="flex justify-between font-body text-[13px]" data-id="element-283">
                  <span className="text-[#E8C855]" data-id="element-284">51-70:</span>
                  <span className="text-[#E8C855]" data-id="element-285">Brecha moderada</span>
                </div>
                <div className="flex justify-between font-body text-[13px]" data-id="element-286">
                  <span className="text-salvia" data-id="element-287">71-85:</span>
                  <span className="text-salvia" data-id="element-288">Presencia sólida</span>
                </div>
                <div className="flex justify-between font-body text-[13px]" data-id="element-289">
                  <span className="text-arena" data-id="element-290">86-100:</span>
                  <span className="text-arena" data-id="element-291">Alto impacto</span>
                </div>
              </div>

              <p className="font-body text-[13px] text-arena/45 italic text-center md:text-right" data-id="element-292">
                Puntuación promedio en empresas B2B colombianas en primer
                análisis: 41/100
              </p>
            </div>
          </div>
        </motion.div>

        <p className="font-body text-[13px] text-carbon/40 text-center mt-4" data-id="element-293">
          El ICD™ es un sistema propietario de Origen Studio.
        </p>
      </div>
    </section>;
}